import { FC } from "react";
import { ChoiceChip, Flex, Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

type VehicleSearchFilterProps = {
  searchQuery: string;
  resultLength: number;
  filterOptions: string[];
  selectedFilter: string | null;
  handleFilterChange: (filter: string) => void;
};

export const VehicleSearchFilter: FC<VehicleSearchFilterProps> = ({
  searchQuery,
  resultLength,
  filterOptions,
  selectedFilter,
  handleFilterChange,
}) => {
  const theme = useTheme();

  return searchQuery.length >= 2 ? (
    <div
      style={{
        backgroundColor: theme.colorBackgroundMain,
        borderWidth: "1px",
        borderRadius: "6px",
        marginTop: "6px",
        padding: "18px",
        borderColor: theme.colorOutlineSecondary,
      }}
    >
      <Text>
        Ditt søk på <b>{searchQuery}</b> ga <b>{resultLength}</b> treff
      </Text>
      <Flex
        color={theme.colorBackgroundMain}
        borderColor={theme.colorOutlineSecondary}
        flexDir="column"
      >
        <Text>Filtrer søk på:</Text>
        <Flex direction="row" gap="6px" wrap="wrap">
          {filterOptions.map((filterOption) => (
            <ChoiceChip
              key={filterOption}
              checked={selectedFilter === filterOption}
              onCheckedChange={() => handleFilterChange(filterOption)}
              textAlign="center"
              width="auto"
            >
              {filterOption}
            </ChoiceChip>
          ))}
        </Flex>
      </Flex>
    </div>
  ) : null;
};
